import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';

/** Корень сайта не принадлежит ни одной студии: у каждой свой адрес /s/{slug}/ */
export function RootPage() {
  return (
    <Center minHeight="100dvh" padding={4}>
      <EmptyState
        title="Онлайн-запись"
        description="Откройте ссылку, которую прислала ваша студия: она выглядит как /s/название-студии/."
      />
    </Center>
  );
}
